// \0@oxc-project+runtime@0.155.0/helpers/esm/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
// src/errors.ts
/** A non-2xx JSON response or a stream `error` event. */
var BuddyApiError = class extends Error {
	constructor(message, status, opts = {}) {
		super(message);
		_defineProperty(this, "status", void 0);
		_defineProperty(this, "code", void 0);
		_defineProperty(this, "limitStatus", void 0);
		_defineProperty(this, "body", void 0);
		_defineProperty(
			this,
			/** Seconds to wait before retrying, from the body's `retryAfter` or the `Retry-After` header (429 only). */
			"retryAfter",
			void 0
		);
		this.name = "BuddyApiError";
		this.status = status;
		this.code = opts.code;
		this.limitStatus = opts.limitStatus;
		this.body = opts.body;
		this.retryAfter = opts.retryAfter;
	}
	get isUnauthorized() {
		return this.status === 401 || this.code === "auth_expired";
	}
	/** Too many sign-in attempts: `rate_limited` per address, `locked_out` per account. Not a token-budget 429. */
	get isRateLimited() {
		return this.code === "rate_limited" || this.code === "locked_out";
	}
	/** The tenant's monthly token budget is used up; a sign-in 429 carries its own code and is excluded. */
	get isLimitExceeded() {
		return this.code === "limit_exceeded" || this.status === 429 && !this.isRateLimited;
	}
};
function isAbortError(e) {
	return e instanceof Error && e.name === "AbortError";
}
/** Turn a failed response into a `BuddyApiError` (ProblemDetails, `{error}` and plain text are all accepted). */
async function errorFromResponse(response) {
	let body;
	let text = "";
	try {
		text = await response.text();
		body = text ? JSON.parse(text) : void 0;
	} catch {
		body = void 0;
	}
	return new BuddyApiError((body === null || body === void 0 ? void 0 : body.error) || (body === null || body === void 0 ? void 0 : body.detail) || (body === null || body === void 0 ? void 0 : body.title) || (text && text.length < 300 && !text.startsWith("<") ? text : "") || `HTTP ${response.status}`, response.status, {
		code: body === null || body === void 0 ? void 0 : body.code,
		limitStatus: body === null || body === void 0 ? void 0 : body.limitStatus,
		body,
		retryAfter: retryAfterSeconds(response, body)
	});
}
/** `retryAfter` in the body wins; the `Retry-After` header is the HTTP fallback (seconds or an HTTP date). */
function retryAfterSeconds(response, body) {
	var _response$headers, _response$headers$get;
	if (typeof (body === null || body === void 0 ? void 0 : body.retryAfter) === "number" && isFinite(body.retryAfter)) return Math.max(0, body.retryAfter);
	const header = (_response$headers = response.headers) === null || _response$headers === void 0 || (_response$headers$get = _response$headers.get) === null || _response$headers$get === void 0 ? void 0 : _response$headers$get.call(_response$headers, "Retry-After");
	if (!header) return void 0;
	const seconds = Number(header);
	if (isFinite(seconds)) return Math.max(0, seconds);
	const at = Date.parse(header);
	return isNaN(at) ? void 0 : Math.max(0, Math.round((at - Date.now()) / 1e3));
}
// src/images.ts
/** Pictures in query results are `nyce-image://<Entity>/<id>/<Requisite>[?format=…&size=…&w=…&h=…]` handles, never bytes
*  (ADR-0007). The API serves the picture behind one at `/chat/image/<Entity>/<id>/<Requisite>` for a bearer, and at
*  `/chat/pdf-image/<renderToken>/…` for the PDF renderer. */
var IMAGE_REF_SCHEME = "nyce-image://";
var REF_RE = /^nyce-image:\/\/([A-Za-z_][A-Za-z0-9_]*)\/(\d{1,9})\/([A-Za-z_][A-Za-z0-9_]*)(?:\?([^\s#]*))?$/;
function isImageRef(value) {
	return typeof value === "string" && value.startsWith("nyce-image://");
}
/** The parts of a handle, or null when the string is not one (the query part is optional). */
function parseImageRef(ref) {
	const m = REF_RE.exec(String(ref !== null && ref !== void 0 ? ref : "").trim());
	if (!m) return null;
	const out = {
		entity: m[1],
		id: Number(m[2]),
		requisite: m[3]
	};
	if (m[4]) for (const pair of m[4].split("&")) {
		const eq = pair.indexOf("=");
		if (eq <= 0) continue;
		const k = pair.slice(0, eq);
		const v = pair.slice(eq + 1);
		if (k === "format") out.format = v;
		else if (k === "size" && /^\d+$/.test(v)) out.size = Number(v);
		else if (k === "w" && /^\d+$/.test(v)) out.width = Number(v);
		else if (k === "h" && /^\d+$/.test(v)) out.height = Number(v);
	}
	return out;
}
/** `/chat/image/<Entity>/<id>/<Requisite>` (relative to the API base), or null for a string that is not a handle. */
function imageRefPath(ref) {
	const r = parseImageRef(ref);
	return r ? `/chat/image/${r.entity}/${r.id}/${r.requisite}` : null;
}
// src/normalize.ts
var ROW_TYPES = /* @__PURE__ */ new Set([
	"insights",
	"table",
	"chart",
	"heatmap",
	"gauge",
	"progress",
	"html",
	"options",
	"input",
	"questionnaire",
	"log"
]);
function isObj(v) {
	return !!v && typeof v === "object" && !Array.isArray(v);
}
/** Old Buddy nested every payload under a key named like the type (`content.table`, `content.chart`, ...). */
function unwrap(type, content) {
	if (isObj(content) && isObj(content[type]) && Object.keys(content).length <= 2) return content[type];
	return content;
}
/** Old Buddy table: `{name, columns:[{title,dataIndex}], data}` or `{headers, rows}`. */
function normalizeTable(c) {
	if (!isObj(c)) return { data: [] };
	const out = { ...c };
	if (!out.title && typeof c.name === "string") out.title = c.name;
	if (Array.isArray(c.headers) && Array.isArray(c.rows) && !Array.isArray(c.data)) {
		const headers = c.headers.map(String);
		out.columns = headers;
		out.data = c.rows.map((row) => Array.isArray(row) ? Object.fromEntries(row.map((v, i) => {
			var _headers$i;
			return [(_headers$i = headers[i]) !== null && _headers$i !== void 0 ? _headers$i : String(i), v];
		})) : row);
		delete out.headers;
		delete out.rows;
	}
	if (Array.isArray(c.columns) && c.columns.length && isObj(c.columns[0])) out.columns = c.columns.map((col) => {
		var _ref, _col$dataIndex;
		return (_ref = (_col$dataIndex = col.dataIndex) !== null && _col$dataIndex !== void 0 ? _col$dataIndex : col.key) !== null && _ref !== void 0 ? _ref : col.title;
	}).filter(Boolean);
	return out;
}
var CHART_KINDS = /* @__PURE__ */ new Set([
	"bar",
	"line",
	"area",
	"pie",
	"donut",
	"radar"
]);
/** Heatmap: string axes and a numeric matrix (null where there is no value); anything else is left as it came. */
function normalizeHeatmap(c) {
	if (!isObj(c)) return {
		xaxis: [],
		yaxis: [],
		values: []
	};
	const out = { ...c };
	const axis = (v) => Array.isArray(v) ? v.map((x) => x == null ? "" : String(x)) : [];
	out.xaxis = axis(c.xaxis);
	out.yaxis = axis(c.yaxis);
	out.values = Array.isArray(c.values) ? c.values.map((row) => Array.isArray(row) ? row.map((v) => typeof v === "number" && Number.isFinite(v) ? v : v == null || v === "" ? null : Number(v)) : []) : [];
	return out;
}
/** Old Buddy chart: `{type:'bar', labels, datasets:[{label, data}]}` or `{categories, series:[{name, values}]}`;
*  the kind is kept when it is one the UI draws (bar, line, area, pie, donut, radar), else bar. */
function normalizeChart(c) {
	var _ref2, _ref3, _c$kind, _ref4, _ref5, _c$xaxis;
	if (!isObj(c)) return {
		kind: "bar",
		xaxis: [],
		series: []
	};
	const out = { ...c };
	const kindRaw = String((_ref2 = (_ref3 = (_c$kind = c.kind) !== null && _c$kind !== void 0 ? _c$kind : c.type) !== null && _ref3 !== void 0 ? _ref3 : c.chartType) !== null && _ref2 !== void 0 ? _ref2 : "").toLowerCase();
	out.kind = CHART_KINDS.has(kindRaw) ? kindRaw : "bar";
	const labels = (_ref4 = (_ref5 = (_c$xaxis = c.xaxis) !== null && _c$xaxis !== void 0 ? _c$xaxis : c.labels) !== null && _ref5 !== void 0 ? _ref5 : c.categories) !== null && _ref4 !== void 0 ? _ref4 : c.x;
	if (Array.isArray(labels)) out.xaxis = labels.map((x) => x == null ? "" : String(x));
	const series = Array.isArray(c.series) ? c.series : Array.isArray(c.datasets) ? c.datasets : void 0;
	if (Array.isArray(series)) out.series = series.filter((s) => isObj(s)).map((s) => {
		var _ref6, _s$name;
		return {
			name: String((_ref6 = (_s$name = s.name) !== null && _s$name !== void 0 ? _s$name : s.label) !== null && _ref6 !== void 0 ? _ref6 : ""),
			data: (Array.isArray(s.data) ? s.data : Array.isArray(s.values) ? s.values : []).map((v) => typeof v === "number" && Number.isFinite(v) ? v : v == null || v === "" ? null : Number(v))
		};
	});
	delete out.labels;
	delete out.datasets;
	delete out.categories;
	if (typeof out.x !== "string") delete out.x;
	return out;
}
/** Canonical row list: drops malformed rows, unwraps nested legacy content, maps old `message` rows to insights. */
function normalizeRows(raw) {
	if (!Array.isArray(raw)) return [];
	const rows = [];
	for (const r of raw) {
		if (!isObj(r) || typeof r.type !== "string") continue;
		let type = r.type;
		let content = r.content;
		if (type === "message") {
			type = "insights";
			content = typeof content === "string" ? { text: content } : content;
		}
		if (!ROW_TYPES.has(type)) continue;
		content = unwrap(type, content);
		if (type === "insights") {
			if (typeof content === "string") content = { text: content };
			else if (isObj(content) && typeof content.text !== "string" && typeof content.markdown === "string") content = { text: content.markdown };
			if (!isObj(content) || typeof content.text !== "string") continue;
		} else if (type === "html") {
			if (typeof content === "string") content = { html: content };
			if (!isObj(content)) continue;
		} else if (type === "table") content = normalizeTable(content);
		else if (type === "chart") content = normalizeChart(content);
		else if (type === "heatmap") content = normalizeHeatmap(content);
		else if (!isObj(content)) continue;
		rows.push({
			type,
			content
		});
	}
	return rows;
}
/** Canonical report from any of: buddyng `{heading, answer, rows}`, old Buddy `{heading, summary[], rows}`,
*  a `{data:{...}}` wrapper, plain markdown text, or the report as a JSON string. */
function normalizeReport(raw) {
	if (typeof raw === "string") {
		const trimmed = raw.trim();
		if (/^[`{]/.test(trimmed)) {
			const json = trimmed.replace(/^```(?:json)?\s*/i, "").replace(/\s*```$/, "");
			try {
				return normalizeReport(JSON.parse(json));
			} catch {}
		}
		return { answer: raw };
	}
	if (!isObj(raw)) return { answer: "" };
	const src = isObj(raw.data) && !("answer" in raw) && !("summary" in raw) && !("rows" in raw) ? raw.data : raw;
	let answer = "";
	if (typeof src.answer === "string") answer = src.answer;
	else if (Array.isArray(src.summary)) answer = src.summary.filter((s) => typeof s === "string").join("\n\n");
	else if (typeof src.summary === "string") answer = src.summary;
	else if (typeof src.text === "string") answer = src.text;
	const report = {
		answer,
		rows: normalizeRows(src.rows)
	};
	if (typeof src.heading === "string" && src.heading) report.heading = src.heading;
	if (typeof src.note === "string" && src.note) report.note = src.note;
	if (typeof src.spoken === "string" && src.spoken.trim()) report.spoken = src.spoken.trim();
	if (Array.isArray(src.clarificationContext)) report.clarificationContext = src.clarificationContext;
	if (typeof src.originalUserQuestion === "string") report.originalUserQuestion = src.originalUserQuestion;
	return report;
}
/** `final_result` (or buddyng's flat `result`) to an `AskResult` with a normalised `report`. */
function normalizeFinalResult(raw) {
	var _d$tokenUsage, _ref7, _d$messageId;
	const d = isObj(raw) ? raw : {};
	const data = isObj(d.data) ? d.data : {
		heading: d.heading,
		answer: d.answer,
		rows: d.rows,
		note: d.note
	};
	const report = normalizeReport(data);
	const tokenUsage = normalizeUsage((_d$tokenUsage = d.tokenUsage) !== null && _d$tokenUsage !== void 0 ? _d$tokenUsage : d.usage);
	return {
		...d,
		messageId: String((_ref7 = (_d$messageId = d.messageId) !== null && _d$messageId !== void 0 ? _d$messageId : d.id) !== null && _ref7 !== void 0 ? _ref7 : ""),
		data,
		queries: Array.isArray(d.queries) ? d.queries : [],
		toolCalls: Array.isArray(d.toolCalls) ? d.toolCalls : [],
		tokenUsage,
		nyceTokens: normalizeNyce(d.nyceTokens),
		weightedTokens: typeof d.weightedTokens === "number" ? d.weightedTokens : void 0,
		elapsedMs: typeof d.elapsedMs === "number" ? d.elapsedMs : d.durationMs,
		report
	};
}
/** Map any known wire frame (nyceBuddy 3 contract, buddyng, old Buddy) to the canonical event union. */
function normalizeStreamEvent(event, data) {
	switch (event) {
		case "progress":
			var _data$step, _ref8, _data$message, _data$turn, _data$stage, _data$state, _ref9, _data$activityId, _data$stage2, _ref10, _data$turn2;
			if (!isObj(data)) return null;
			if (data.stage === "answer" && isObj(data.data) && typeof data.data.delta === "string") return {
				event: "answer",
				data: {
					delta: data.data.delta,
					turn: (_data$step = data.step) !== null && _data$step !== void 0 ? _data$step : data.turn
				}
			};
			return {
				event: "progress",
				data: {
					message: String((_ref8 = (_data$message = data.message) !== null && _data$message !== void 0 ? _data$message : data.title) !== null && _ref8 !== void 0 ? _ref8 : ""),
					titleKey: data.titleKey,
					turn: (_data$turn = data.turn) !== null && _data$turn !== void 0 ? _data$turn : data.step,
					stage: (_data$stage = data.stage) !== null && _data$stage !== void 0 ? _data$stage : "model",
					state: (_data$state = data.state) !== null && _data$state !== void 0 ? _data$state : "running",
					activityId: String((_ref9 = (_data$activityId = data.activityId) !== null && _data$activityId !== void 0 ? _data$activityId : data.id) !== null && _ref9 !== void 0 ? _ref9 : `${(_data$stage2 = data.stage) !== null && _data$stage2 !== void 0 ? _data$stage2 : "model"}:${(_ref10 = (_data$turn2 = data.turn) !== null && _data$turn2 !== void 0 ? _data$turn2 : data.step) !== null && _ref10 !== void 0 ? _ref10 : 0}`),
					detail: data.detail,
					data: data.data,
					usage: data.usage
				}
			};
		case "function_call":
			var _data$activityId2, _data$turn3;
			return isObj(data) && typeof data.functionName === "string" ? {
				event: "function_call",
				data: {
					...data,
					activityId: String((_data$activityId2 = data.activityId) !== null && _data$activityId2 !== void 0 ? _data$activityId2 : `${data.functionName}:${(_data$turn3 = data.turn) !== null && _data$turn3 !== void 0 ? _data$turn3 : 0}`)
				}
			} : null;
		case "function_result":
			var _data$activityId3, _data$turn4;
			return isObj(data) && typeof data.functionName === "string" ? {
				event: "function_result",
				data: {
					...data,
					activityId: String((_data$activityId3 = data.activityId) !== null && _data$activityId3 !== void 0 ? _data$activityId3 : `${data.functionName}:${(_data$turn4 = data.turn) !== null && _data$turn4 !== void 0 ? _data$turn4 : 0}`)
				}
			} : null;
		case "answer":
		case "data":
			if (!isObj(data)) return null;
			if (typeof data.delta === "string") return {
				event: "answer",
				data: {
					delta: data.delta,
					turn: data.turn
				}
			};
			return null;
		case "final_result":
		case "result": return {
			event: "final_result",
			data: normalizeFinalResult(data)
		};
		case "error":
			var _ref11, _data$message2;
			return {
				event: "error",
				data: {
					message: String((_ref11 = (_data$message2 = data === null || data === void 0 ? void 0 : data.message) !== null && _data$message2 !== void 0 ? _data$message2 : data === null || data === void 0 ? void 0 : data.error) !== null && _ref11 !== void 0 ? _ref11 : "The investigation failed."),
					code: data === null || data === void 0 ? void 0 : data.code,
					log: data === null || data === void 0 ? void 0 : data.log
				}
			};
		case "accepted": return isObj(data) && typeof data.turnId === "string" ? {
			event: "accepted",
			data: {
				turnId: data.turnId,
				sessionId: data.sessionId
			}
		} : null;
		case "auth_expired": return {
			event: "auth_expired",
			data: isObj(data) ? data : {}
		};
		case "keep_alive": return {
			event: "keep_alive",
			data: isObj(data) ? data : {}
		};
		case "complete": return {
			event: "complete",
			data: isObj(data) ? data : {}
		};
		case "log": return isObj(data) && typeof data.message === "string" ? {
			event: "log",
			data: { message: data.message }
		} : null;
		default: return null;
	}
}
/** `nyceTokens`: what the turn cost the budget, split per part. Absent on a backend older than ADR-0009. */
function normalizeNyce(raw) {
	if (!isObj(raw)) return void 0;
	const n = (v) => typeof v === "number" && Number.isFinite(v) ? v : 0;
	const parts = {
		input: n(raw.input),
		cached: n(raw.cached),
		output: n(raw.output),
		thoughts: n(raw.thoughts)
	};
	return {
		total: typeof raw.total === "number" ? raw.total : parts.input + parts.cached + parts.output + parts.thoughts,
		...parts
	};
}
/** `tokenUsage`: the backend sends `calls` either as a count (buddyng) or as the per-step array; keep both. */
function normalizeUsage(raw) {
	var _steps$length;
	const u = isObj(raw) ? raw : {};
	const steps = Array.isArray(u.calls) ? u.calls : Array.isArray(u.steps) ? u.steps : void 0;
	const num = (v, d = 0) => typeof v === "number" && Number.isFinite(v) ? v : d;
	const out = {
		prompt: num(u.prompt),
		cached: num(u.cached),
		output: num(u.output),
		thoughts: num(u.thoughts),
		calls: typeof u.calls === "number" ? u.calls : (_steps$length = steps === null || steps === void 0 ? void 0 : steps.length) !== null && _steps$length !== void 0 ? _steps$length : 0
	};
	if (typeof u.nyceTokens === "number") out.nyceTokens = u.nyceTokens;
	if (typeof u.fresh === "number") out.fresh = u.fresh;
	else if (out.prompt || out.cached) out.fresh = Math.max(0, out.prompt - out.cached);
	if (typeof u.cacheMode === "string") out.cacheMode = u.cacheMode;
	if (steps) out.steps = steps.filter(isObj).map((s, i) => {
		var _s$tool, _s$prompt, _s$cached, _s$prompt2, _s$cached2, _ref12, _s$output, _s$thoughts;
		return {
			step: typeof s.step === "number" ? s.step : i + 1,
			model: s.model,
			tool: (_s$tool = s.tool) !== null && _s$tool !== void 0 ? _s$tool : s.name,
			prompt: num((_s$prompt = s.prompt) !== null && _s$prompt !== void 0 ? _s$prompt : s.promptTokens),
			cached: num((_s$cached = s.cached) !== null && _s$cached !== void 0 ? _s$cached : s.cachedTokens),
			fresh: typeof s.fresh === "number" ? s.fresh : Math.max(0, num((_s$prompt2 = s.prompt) !== null && _s$prompt2 !== void 0 ? _s$prompt2 : s.promptTokens) - num((_s$cached2 = s.cached) !== null && _s$cached2 !== void 0 ? _s$cached2 : s.cachedTokens)),
			output: num((_ref12 = (_s$output = s.output) !== null && _s$output !== void 0 ? _s$output : s.outputTokens) !== null && _ref12 !== void 0 ? _ref12 : s.responseTokens),
			thoughts: num((_s$thoughts = s.thoughts) !== null && _s$thoughts !== void 0 ? _s$thoughts : s.thoughtTokens),
			cacheMode: s.cacheMode,
			ms: typeof s.ms === "number" ? s.ms : typeof s.durationMs === "number" ? s.durationMs : void 0
		};
	});
	if (isObj(u.context)) out.context = {
		notes: num(u.context.notes),
		summary: num(u.context.summary),
		digests: num(u.context.digests),
		frames: num(u.context.frames),
		total: num(u.context.total),
		budget: typeof u.context.budget === "number" ? u.context.budget : void 0,
		dropped: Array.isArray(u.context.dropped) ? u.context.dropped.map(String) : []
	};
	return out;
}
/** A persisted message in either the canonical shape or the old Buddy shape (`isUser`, `userQuestion`, `response`). */
/** Persisted user-message attachments: names, kinds and sizes only (`{id, fileName, kind, size?, rows?}` or old `{name, kind}`). */
function normalizeAttachments(raw) {
	if (!Array.isArray(raw)) return void 0;
	const list = raw.filter(isObj).map((a, i) => {
		var _ref13, _a$id, _ref14, _ref15, _a$fileName, _a$kind;
		return {
			id: String((_ref13 = (_a$id = a.id) !== null && _a$id !== void 0 ? _a$id : a.attachmentId) !== null && _ref13 !== void 0 ? _ref13 : `att-${i}`),
			fileName: String((_ref14 = (_ref15 = (_a$fileName = a.fileName) !== null && _a$fileName !== void 0 ? _a$fileName : a.name) !== null && _ref15 !== void 0 ? _ref15 : a.filename) !== null && _ref14 !== void 0 ? _ref14 : ""),
			kind: String((_a$kind = a.kind) !== null && _a$kind !== void 0 ? _a$kind : "text"),
			size: typeof a.size === "number" ? a.size : void 0,
			rows: typeof a.rows === "number" ? a.rows : typeof a.rowCount === "number" ? a.rowCount : void 0
		};
	}).filter((a) => a.fileName);
	return list.length ? list : void 0;
}
function normalizeMessage(raw, index = 0) {
	var _ref16, _raw$timestamp, _ref17, _raw$id, _ref21, _ref22, _raw$report, _resultSrc$messageId, _raw$thinking2;
	if (!isObj(raw)) return null;
	const role = raw.role === "user" || raw.role === "assistant" ? raw.role : raw.isUser ? "user" : raw.role === "clarification" ? "user" : "assistant";
	const timestamp = String((_ref16 = (_raw$timestamp = raw.timestamp) !== null && _raw$timestamp !== void 0 ? _raw$timestamp : raw.createdAt) !== null && _ref16 !== void 0 ? _ref16 : (/* @__PURE__ */ new Date()).toISOString());
	const id = String((_ref17 = (_raw$id = raw.id) !== null && _raw$id !== void 0 ? _raw$id : raw.messageId) !== null && _ref17 !== void 0 ? _ref17 : `${role}-${index}`);
	if (role === "user") {
		var _ref18, _ref19, _ref20, _raw$text, _raw$thinking;
		return {
			id,
			role,
			text: String((_ref18 = (_ref19 = (_ref20 = (_raw$text = raw.text) !== null && _raw$text !== void 0 ? _raw$text : raw.question) !== null && _ref20 !== void 0 ? _ref20 : raw.userQuestion) !== null && _ref19 !== void 0 ? _ref19 : raw.message) !== null && _ref18 !== void 0 ? _ref18 : ""),
			timestamp,
			thinking: (_raw$thinking = raw.thinking) !== null && _raw$thinking !== void 0 ? _raw$thinking : raw.thinkingLevel,
			isClarificationResponse: raw.role === "clarification" || !!raw.isClarificationResponse,
			clarification: raw.clarification,
			attachments: normalizeAttachments(raw.attachments)
		};
	}
	const reportSrc = (_ref21 = (_ref22 = (_raw$report = raw.report) !== null && _raw$report !== void 0 ? _raw$report : raw.response) !== null && _ref22 !== void 0 ? _ref22 : raw.data) !== null && _ref21 !== void 0 ? _ref21 : raw.answer != null || raw.rows ? raw : void 0;
	const report = reportSrc ? normalizeReport(reportSrc) : void 0;
	const resultSrc = isObj(raw.result) ? raw.result : raw;
	const result = isObj(resultSrc) && (Array.isArray(resultSrc.queries) || resultSrc.tokenUsage || resultSrc.analysis || resultSrc.toolCalls) ? normalizeFinalResult({
		...resultSrc,
		messageId: (_resultSrc$messageId = resultSrc.messageId) !== null && _resultSrc$messageId !== void 0 ? _resultSrc$messageId : id,
		data: reportSrc !== null && reportSrc !== void 0 ? reportSrc : {}
	}) : void 0;
	let stripped;
	if (result) {
		const { report: _r, data: _d, ...rest } = result;
		stripped = rest;
	}
	return {
		id,
		role,
		text: typeof raw.text === "string" && !(report === null || report === void 0 ? void 0 : report.answer) && !(report === null || report === void 0 ? void 0 : report.heading) ? raw.text : "",
		report,
		result: stripped,
		timestamp,
		thinking: (_raw$thinking2 = raw.thinking) !== null && _raw$thinking2 !== void 0 ? _raw$thinking2 : raw.thinkingLevel,
		feedback: raw.feedback,
		error: typeof raw.error === "string" ? raw.error : void 0,
		cancelled: !!raw.cancelled
	};
}
function normalizeConversation(raw) {
	var _c$id, _ref23, _c$sessionId, _c$title, _c$createdAt, _ref24, _c$updatedAt;
	const c = isObj(raw) ? raw : {};
	const messages = (Array.isArray(c.messages) ? c.messages : []).map((m, i) => normalizeMessage(m, i)).filter((m) => !!m);
	return {
		id: String((_c$id = c.id) !== null && _c$id !== void 0 ? _c$id : ""),
		sessionId: String((_ref23 = (_c$sessionId = c.sessionId) !== null && _c$sessionId !== void 0 ? _c$sessionId : c.id) !== null && _ref23 !== void 0 ? _ref23 : ""),
		title: String((_c$title = c.title) !== null && _c$title !== void 0 ? _c$title : ""),
		preview: c.preview,
		messageCount: typeof c.messageCount === "number" ? c.messageCount : messages.length,
		createdAt: String((_c$createdAt = c.createdAt) !== null && _c$createdAt !== void 0 ? _c$createdAt : ""),
		updatedAt: String((_ref24 = (_c$updatedAt = c.updatedAt) !== null && _c$updatedAt !== void 0 ? _c$updatedAt : c.createdAt) !== null && _ref24 !== void 0 ? _ref24 : ""),
		isStarred: !!c.isStarred,
		messages
	};
}
/** A frame page: rows as objects or as arrays (`columns` + `rows[][]`). */
function normalizeFramePage(raw, frame, offset, limit) {
	const p = isObj(raw) ? raw : {};
	const rowsRaw = Array.isArray(p.rows) ? p.rows : Array.isArray(p.data) ? p.data : [];
	let columns = Array.isArray(p.columns) ? p.columns.map(String) : [];
	const rows = rowsRaw.map((r) => Array.isArray(r) ? Object.fromEntries(r.map((v, i) => {
		var _columns$i;
		return [(_columns$i = columns[i]) !== null && _columns$i !== void 0 ? _columns$i : String(i), v];
	})) : isObj(r) ? r : { value: r });
	if (!columns.length) columns = [...new Set(rows.flatMap((r) => Object.keys(r)))];
	return {
		frame: typeof p.frame === "number" ? p.frame : frame,
		columns,
		rows,
		total: typeof p.total === "number" ? p.total : typeof p.rowCount === "number" ? p.rowCount : offset + rows.length,
		offset: typeof p.offset === "number" ? p.offset : offset,
		limit: typeof p.limit === "number" ? p.limit : limit !== null && limit !== void 0 ? limit : rows.length,
		truncated: !!p.truncated
	};
}
/** The API sends `system` as `{ id, ... }` on /login, /login/ticket, /login/redeem and /me; older builds and mocks send the id,
*  a platform sign-in without a system sends null. Either way `system` becomes the id string (it goes into `X-Nyce-System`;
*  '' = none, the header is not sent) and the object, when there was one, `systemInfo`. */
function normalizeSystemRef(raw) {
	const s = raw === null || raw === void 0 ? void 0 : raw.system;
	if (s && typeof s === "object") {
		var _ref$id, _raw$systemInfo;
		const ref = s;
		return {
			...raw,
			system: String((_ref$id = ref.id) !== null && _ref$id !== void 0 ? _ref$id : ""),
			systemInfo: (_raw$systemInfo = raw.systemInfo) !== null && _raw$systemInfo !== void 0 ? _raw$systemInfo : ref
		};
	}
	return {
		...raw,
		system: typeof s === "string" ? s : ""
	};
}
/** `GET /chat/pdf-data/{token}`: the documented `{report, evidence, meta}`; a flat `{heading, answer, rows, queries, …}`
*  (older builds) is folded into it, so the export page never reads `report` off undefined. */
/** `/chat/pdf-data/{token}` answers with one report or a whole conversation; the page branches on the shape. */
function normalizePdfPayload(raw) {
	if (raw && typeof raw === "object" && raw.conversation) {
		const c = raw.conversation;
		return {
			...raw,
			conversation: {
				...c,
				entries: (Array.isArray(c.entries) ? c.entries : []).map((e) => ({
					...e,
					report: (e === null || e === void 0 ? void 0 : e.report) ? normalizeReport(e.report) : null
				}))
			}
		};
	}
	return normalizePdfData(raw);
}
function normalizePdfData(raw) {
	var _r$queries, _r$user;
	if (raw && typeof raw === "object" && raw.report) return {
		...raw,
		report: normalizeReport(raw.report)
	};
	const r = raw !== null && raw !== void 0 ? raw : {};
	return {
		report: normalizeReport({
			heading: r.heading,
			answer: r.answer,
			rows: r.rows
		}),
		evidence: r.queries || r.analysis ? {
			queries: (_r$queries = r.queries) !== null && _r$queries !== void 0 ? _r$queries : [],
			analysis: r.analysis
		} : void 0,
		meta: {
			messageId: r.messageId,
			question: r.question,
			userName: (_r$user = r.user) !== null && _r$user !== void 0 ? _r$user : r.userName,
			systemName: r.systemName,
			tenantName: r.tenantName,
			createdAt: r.createdAt,
			model: r.model
		}
	};
}
// src/sse.ts
/** Incremental parser: feed bytes or text, get complete frames back. */
var SseParser = class {
	constructor() {
		_defineProperty(this, "buffer", "");
		_defineProperty(this, "decoder", new TextDecoder());
	}
	push(chunk, done = false) {
		if (chunk && typeof chunk !== "string" && ArrayBuffer.isView(chunk)) this.buffer += this.decoder.decode(chunk, { stream: !done });
		else if (typeof chunk === "string") this.buffer += chunk;
		else if (done) this.buffer += this.decoder.decode();
		if (this.buffer.charCodeAt(0) === 65279) this.buffer = this.buffer.slice(1);
		const frames = [];
		let boundary;
		while (boundary = /\r?\n\r?\n/.exec(this.buffer)) {
			const block = this.buffer.slice(0, boundary.index);
			this.buffer = this.buffer.slice(boundary.index + boundary[0].length);
			const frame = parseBlock(block);
			if (frame) frames.push(frame);
		}
		if (done && this.buffer.trim()) {
			const frame = parseBlock(this.buffer);
			this.buffer = "";
			if (frame) frames.push(frame);
		}
		return frames;
	}
};
function parseBlock(block) {
	let event = "message";
	let id;
	const lines = [];
	for (const line of block.split(/\r?\n/)) {
		if (!line || line.startsWith(":")) continue;
		const colon = line.indexOf(":");
		const field = colon < 0 ? line : line.slice(0, colon);
		let value = colon < 0 ? "" : line.slice(colon + 1);
		if (value.startsWith(" ")) value = value.slice(1);
		if (field === "event") event = value.trim();
		else if (field === "data") lines.push(value);
		else if (field === "id") id = value;
	}
	if (!lines.length) return null;
	return {
		event,
		data: lines.join("\n"),
		id
	};
}
/** Read a streaming response and call `onFrame` for every complete frame until the body ends, `onFrame` returns
*  `true`, or `signal` aborts. Throws a `StallError` when `stallMs` passes without bytes. */
async function readSse(response, onFrame, signal, options = {}) {
	var _options$stallMs;
	if (!response.body) throw new Error("This browser cannot read live responses.");
	const reader = response.body.getReader();
	const parser = new SseParser();
	const stallMs = (_options$stallMs = options.stallMs) !== null && _options$stallMs !== void 0 ? _options$stallMs : 0;
	const onAbort = () => {
		reader.cancel().catch(() => {});
	};
	signal === null || signal === void 0 || signal.addEventListener("abort", onAbort, { once: true });
	try {
		while (true) {
			if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw abortError();
			const { value, done } = stallMs > 0 ? await readWithWatchdog(reader, stallMs) : await reader.read();
			if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw abortError();
			for (const frame of parser.push(value, done)) if (await onFrame(frame) === true) return;
			if (done) return;
		}
	} finally {
		signal === null || signal === void 0 || signal.removeEventListener("abort", onAbort);
		try {
			await reader.cancel();
		} catch {}
		try {
			reader.releaseLock();
		} catch {}
	}
}
function readWithWatchdog(reader, ms) {
	return new Promise((resolve, reject) => {
		const timer = setTimeout(() => {
			reader.cancel().catch(() => {});
			reject(stallError());
		}, ms);
		reader.read().then((v) => {
			clearTimeout(timer);
			resolve(v);
		}, (e) => {
			clearTimeout(timer);
			reject(e);
		});
	});
}
function abortError() {
	if (typeof DOMException === "function") return new DOMException("The request was cancelled.", "AbortError");
	const e = /* @__PURE__ */ new Error("The request was cancelled.");
	e.name = "AbortError";
	return e;
}
function stallError() {
	const e = /* @__PURE__ */ new Error("No data from the server for a while; the connection is treated as lost.");
	e.name = "StallError";
	return e;
}
function isStallError(e) {
	return e instanceof Error && e.name === "StallError";
}
function isEventStream(response) {
	return (response.headers.get("content-type") || "").toLowerCase().includes("text/event-stream");
}
// src/client.ts
/** Delays between reconnect attempts to a turn whose connection dropped: quick first, then patient (~2 min in all). */
var DEFAULT_RESUME_DELAYS = [
	1e3,
	2e3,
	5e3,
	1e4,
	15e3,
	3e4,
	3e4,
	3e4
];
/** Three missed keep-alives (15 s each) = a dead connection. */
var DEFAULT_STALL_MS = 45e3;
/** Legs of one turn (first connection + reconnects) before the client gives up on a stream that keeps ending early. */
var MAX_LEGS = 20;
function createBuddyClient(options) {
	var _options$fetch, _options$retryDelays, _options$resumeDelays, _options$stallTimeout, _options$sleep;
	const baseUrl = options.baseUrl.replace(/\/+$/, "");
	const fetchImpl = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : ((...args) => globalThis.fetch(...args));
	const retryDelays = (_options$retryDelays = options.retryDelays) !== null && _options$retryDelays !== void 0 ? _options$retryDelays : [1e3, 3e3];
	const resumeDelays = (_options$resumeDelays = options.resumeDelays) !== null && _options$resumeDelays !== void 0 ? _options$resumeDelays : DEFAULT_RESUME_DELAYS;
	const stallMs = (_options$stallTimeout = options.stallTimeoutMs) !== null && _options$stallTimeout !== void 0 ? _options$stallTimeout : DEFAULT_STALL_MS;
	const sleep = (_options$sleep = options.sleep) !== null && _options$sleep !== void 0 ? _options$sleep : ((ms) => new Promise((r) => setTimeout(r, ms)));
	/** `sleep(ms)` that returns early when the device comes back online, the tab becomes visible or the caller aborts. */
	function pause(ms, signal) {
		return new Promise((resolve) => {
			let done = false;
			const finish = () => {
				if (done) return;
				done = true;
				if (typeof window !== "undefined") window.removeEventListener("online", finish);
				if (typeof document !== "undefined") document.removeEventListener("visibilitychange", onVisible);
				signal === null || signal === void 0 || signal.removeEventListener("abort", finish);
				resolve();
			};
			const onVisible = () => {
				if (document.visibilityState === "visible") finish();
			};
			if (typeof window !== "undefined") window.addEventListener("online", finish);
			if (typeof document !== "undefined") document.addEventListener("visibilitychange", onVisible);
			signal === null || signal === void 0 || signal.addEventListener("abort", finish);
			sleep(ms).then(finish);
		});
	}
	let system = options.system;
	async function headers(withAuth, extra) {
		const h = {
			"Content-Type": "application/json",
			...extra
		};
		if (h["Content-Type"] === "") delete h["Content-Type"];
		if (system) h["X-Nyce-System"] = system;
		if (options.clientVersion) h["X-Client-Version"] = options.clientVersion;
		if (withAuth) {
			const token = await options.auth.getToken();
			if (token) h["Authorization"] = `Bearer ${token}`;
		}
		return h;
	}
	/** One refresh on 401, then the request is retried once with the new token. */
	async function withRefresh(send) {
		var _options$auth$onAuthE2, _options$auth2;
		let response = await send();
		if (response.status !== 401) return response;
		const fresh = options.auth.refresh ? await options.auth.refresh().catch(() => null) : null;
		if (!fresh) {
			var _options$auth$onAuthE, _options$auth;
			(_options$auth$onAuthE = (_options$auth = options.auth).onAuthExpired) === null || _options$auth$onAuthE === void 0 || _options$auth$onAuthE.call(_options$auth, options.auth.refresh ? "refresh-failed" : "unauthorized");
			return response;
		}
		response = await send(fresh);
		if (response.status === 401) (_options$auth$onAuthE2 = (_options$auth2 = options.auth).onAuthExpired) === null || _options$auth$onAuthE2 === void 0 || _options$auth$onAuthE2.call(_options$auth2, "unauthorized");
		return response;
	}
	/** `body` with the refresh token of a newly minted sign-in when `want`, the host can mint one and the body has none. */
	async function withChain(body, want) {
		if (!want || body.refreshToken || typeof options.auth.freshChain !== "function") return body;
		try {
			const refreshToken = await options.auth.freshChain();
			return refreshToken ? {
				...body,
				refreshToken
			} : body;
		} catch {
			return body;
		}
	}
	async function request(method, path, body, opts = {}) {
		const withAuth = opts.auth !== false;
		const send = async (token) => {
			const h = await headers(withAuth, opts.headers);
			if (token) h["Authorization"] = `Bearer ${token}`;
			return fetchImpl(`${baseUrl}${path}`, {
				method,
				headers: h,
				body: body === void 0 ? void 0 : JSON.stringify(body),
				signal: opts.signal
			});
		};
		const response = withAuth ? await withRefresh(send) : await send();
		if (!response.ok) throw await errorFromResponse(response);
		if (response.status === 204) return void 0;
		const text = await response.text();
		return text ? JSON.parse(text) : void 0;
	}
	/** Like `request` but with a prepared body (bytes/gzip) or a binary response. */
	async function requestRaw(method, path, body, opts = {}) {
		const withAuth = opts.auth !== false;
		const send = async (token) => {
			const h = await headers(withAuth, {
				...opts.accept ? { Accept: opts.accept } : {},
				...opts.headers
			});
			if (token) h["Authorization"] = `Bearer ${token}`;
			return fetchImpl(`${baseUrl}${path}`, {
				method,
				headers: h,
				body,
				signal: opts.signal
			});
		};
		const response = withAuth ? await withRefresh(send) : await send();
		if (!response.ok) throw await errorFromResponse(response);
		return response;
	}
	const GZIP_THRESHOLD = 102400;
	/** JSON POST; bodies over 100 KB are gzip-compressed when `CompressionStream` exists (`Content-Encoding: gzip`). */
	async function postJsonMaybeGzip(path, body) {
		const json = JSON.stringify(body);
		const CS = globalThis.CompressionStream;
		if (json.length < GZIP_THRESHOLD || !CS) return request("POST", path, body);
		const stream = new Blob([json]).stream().pipeThrough(new CS("gzip"));
		const text = await (await requestRaw("POST", path, new Uint8Array(await new Response(stream).arrayBuffer()), { headers: { "Content-Encoding": "gzip" } })).text();
		return text ? JSON.parse(text) : void 0;
	}
	const qs = (params) => {
		const q = new URLSearchParams();
		for (const [k, v] of Object.entries(params)) if (v !== void 0 && v !== null && v !== "" && v !== false) q.set(k, Array.isArray(v) ? v.join(",") : String(v));
		const str = q.toString();
		return str ? `?${str}` : "";
	};
	/**
	* One connection's worth of frames. Resolves `true` when the connection dropped before a terminal event (body ended,
	* network error, stall) — the turn may still be running on the server — and `false` when the turn is over.
	*/
	async function readLeg(response, turn, opts) {
		const { signal, onEvent } = opts;
		let terminal = false;
		try {
			await readSse(response, (frame) => {
				if (frame.id) turn.lastId = frame.id;
				let parsed;
				try {
					parsed = JSON.parse(frame.data);
				} catch {
					return;
				}
				const event = normalizeStreamEvent(frame.event, parsed);
				if (!event) return;
				if (event.event === "accepted") turn.id = event.data.turnId;
				onEvent === null || onEvent === void 0 || onEvent(event);
				switch (event.event) {
					case "final_result":
						turn.result = event.data;
						terminal = true;
						return true;
					case "error":
						turn.failure = new BuddyApiError(event.data.message, 200, { code: event.data.code });
						terminal = true;
						return true;
					case "auth_expired":
						var _options$auth$onAuthE3, _options$auth3;
						(_options$auth$onAuthE3 = (_options$auth3 = options.auth).onAuthExpired) === null || _options$auth$onAuthE3 === void 0 || _options$auth$onAuthE3.call(_options$auth3, "server");
						turn.failure = new BuddyApiError(event.data.message || "Your session has expired. Please sign in again.", 401, { code: "auth_expired" });
						terminal = true;
						return true;
					case "complete":
						terminal = true;
						return true;
					default: return;
				}
			}, signal, { stallMs });
		} catch (e) {
			if (isAbortError(e) || (signal === null || signal === void 0 ? void 0 : signal.aborted)) throw abortError();
			return !turn.result && !turn.failure;
		}
		return !terminal && !turn.result && !turn.failure;
	}
	/**
	* Re-opens the stream of a turn after its connection dropped: `GET /chat/conversation/stream/{turnId}?after=<lastId>`,
	* retried along `delays` (early when the device comes online or the tab shows again). 404 = this server does not know
	* the turn yet (another replica, a restart while the answer is still being written to the store): keep trying within
	* the budget. Resolves `undefined` when the budget is spent.
	*/
	async function reconnect(turn, delays, signal) {
		const id = turn.id;
		const sendResume = async (token) => {
			const h = await headers(true, {
				Accept: "text/event-stream",
				"Cache-Control": "no-cache"
			});
			if (token) h["Authorization"] = `Bearer ${token}`;
			const after = turn.lastId ? `?after=${encodeURIComponent(turn.lastId)}` : "";
			return fetchImpl(`${baseUrl}/chat/conversation/stream/${encodeURIComponent(id)}${after}`, {
				method: "GET",
				headers: h,
				signal
			});
		};
		for (const delay of delays) {
			if (delay > 0) await pause(delay, signal);
			if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw abortError();
			try {
				const response = await withRefresh(sendResume);
				if (response.status === 404) continue;
				if (!response.ok) throw await errorFromResponse(response);
				if (!isEventStream(response)) continue;
				return response;
			} catch (e) {
				if (isAbortError(e) || (signal === null || signal === void 0 ? void 0 : signal.aborted)) throw abortError();
				if (e instanceof BuddyApiError) throw e;
			}
		}
	}
	/** Reads legs until the turn ends, reconnecting in between; resolves with the `final_result`. */
	async function followTurn(first, turn, opts, immediate) {
		const { signal, onConnection } = opts;
		let dropped = first ? await readLeg(first, turn, opts) : true;
		for (let leg = 1; dropped && opts.resume !== false && turn.id && leg < MAX_LEGS; leg++) {
			onConnection === null || onConnection === void 0 || onConnection("reconnecting");
			const response = await reconnect(turn, immediate && leg === 1 ? [0, ...resumeDelays] : resumeDelays, signal);
			if (!response) break;
			onConnection === null || onConnection === void 0 || onConnection("connected");
			dropped = await readLeg(response, turn, opts);
		}
		if (turn.failure) throw turn.failure;
		if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw abortError();
		if (!turn.result) throw new Error("Connection ended before the agent finished. Partial progress is shown below.");
		return turn.result;
	}
	/**
	* The streaming turn. Resolves with the `final_result`; every event goes to `onEvent` first. A dropped connection does
	* not end the turn: the server keeps working and the client re-attaches (`onConnection` reports it) — a phone that
	* locks its screen mid-question still gets its answer.
	*/
	async function ask(req, opts = {}) {
		const { signal } = opts;
		const body = JSON.stringify(req);
		const send = async (token) => {
			const h = await headers(true, {
				Accept: "text/event-stream",
				"Cache-Control": "no-cache"
			});
			if (token) h["Authorization"] = `Bearer ${token}`;
			return fetchImpl(`${baseUrl}/chat/conversation/stream`, {
				method: "POST",
				headers: h,
				body,
				signal
			});
		};
		let response;
		for (let attempt = 0;; attempt++) {
			if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw abortError();
			try {
				response = await withRefresh(send);
				break;
			} catch (e) {
				if (isAbortError(e) || (signal === null || signal === void 0 ? void 0 : signal.aborted)) throw abortError();
				if (attempt >= retryDelays.length) throw e instanceof Error ? e : new Error(String(e));
				await sleep(retryDelays[attempt]);
			}
		}
		if (!isEventStream(response)) {
			if (!response.ok) throw await errorFromResponse(response);
			return normalizeFinalResult(await response.json());
		}
		return followTurn(response, {}, opts, false);
	}
	/**
	* Re-attach to a turn the server holds (`activeTurn` found one after a reload): the frames after `after`, then the
	* live ones, resolving with the `final_result` like `ask`.
	*/
	function attachTurn(turnId, opts = {}) {
		return followTurn(void 0, {
			id: turnId,
			lastId: opts.after ? String(opts.after) : void 0
		}, opts, true);
	}
	/** Stops a running turn on the server (the abort signal alone only closes this connection). */
	async function cancelTurn(turnId) {
		const r = await request("POST", "/chat/conversation/cancel", { turnId });
		return !!(r === null || r === void 0 ? void 0 : r.cancelled);
	}
	/** The turn the server holds for a session (running, or finished recently), or null. */
	async function activeTurn(sessionId) {
		var _r$turn;
		const r = await request("GET", `/chat/conversation/turn?sessionId=${encodeURIComponent(sessionId)}`);
		return (_r$turn = r === null || r === void 0 ? void 0 : r.turn) !== null && _r$turn !== void 0 ? _r$turn : null;
	}
	return {
		baseUrl,
		get system() {
			return system;
		},
		setSystem(id) {
			system = id;
		},
		request,
		ask,
		attachTurn,
		cancelTurn,
		activeTurn,
		/**
		* The login picker's systems for one address. `host` and `path` are the browser's: a system whose URI pattern names
		* a path (`…/stark`) is listed on that path and nowhere else, so a customer's own entry point shows their systems
		* rather than every system we host. Without them the list is everything that does not belong to a path of its own.
		*/
		systems: (host, path) => {
			const q = new URLSearchParams();
			if (host) q.set("host", host);
			if (path) q.set("path", path);
			const qs = q.toString();
			return request("GET", `/systems${qs ? `?${qs}` : ""}`, void 0, { auth: false });
		},
		loginOptions: () => request("GET", "/login/options", void 0, { auth: false }),
		login: (body) => request("POST", "/login", body, { auth: false }).then(normalizeSystemRef),
		loginTicket: (body) => request("POST", "/login/ticket", body, { auth: false }).then(normalizeSystemRef),
		loginLaunch: (body) => request("POST", "/login/launch", body, { auth: false }),
		loginRedeem: (body) => request("POST", "/login/redeem", body, { auth: false }).then(normalizeSystemRef),
		refresh: (refreshToken) => request("POST", "/refresh", { refresh_token: refreshToken }, { auth: false }),
		/** The consent page of the OAuth flow for `/mcp` (ADR-0016). */
		oauth: {
			check: (params) => request("POST", "/oauth/authorize/check", params, { auth: false }),
			/** `accessToken` is the consent page's own sign-in, not the stored session: it signs in afresh and hands that
			*  chain to the client. */
			approve: (body, accessToken) => request("POST", "/oauth/authorize/approve", body, {
				auth: false,
				headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : void 0
			})
		},
		logout: (refreshToken) => request("POST", "/logout", refreshToken ? { refresh_token: refreshToken } : {}),
		me: (signal) => request("GET", "/me", void 0, { signal }).then(normalizeSystemRef),
		newConversation: (sessionId) => request("POST", "/chat/conversation/new", { sessionId }),
		/**
		* Natural language -> one literal query, for a host that renders rows itself (the NYCE.LOGIC client's search
		* form). Nothing is executed here. A question that cannot be turned into a query answers 422; the thrown
		* BuddyApiError carries `understood: false` and `error`.
		*/
		queryFromText: (body) => request("POST", "/chat/query-from-text", body),
		/**
		* The same call, streamed: `onStep` is called with one pre-phrased line per step and the promise resolves with the
		* same response `queryFromText` returns. The steps are worth showing here — the agent writes a query, reads the
		* parser's rejection and corrects it, and a plain spinner hides exactly the part that takes the time.
		*
		* Falls back to the plain POST when the server answers with JSON rather than a stream, so a host can use this
		* unconditionally against an older API.
		*/
		queryFromTextStream: async (body, opts = {}) => {
			var _result$error;
			const response = await requestRaw("POST", "/chat/query-from-text", JSON.stringify(body), {
				accept: "text/event-stream",
				headers: { "Content-Type": "application/json" },
				signal: opts.signal
			});
			if (!isEventStream(response)) return await response.json();
			let result;
			let failure;
			await readSse(response, (frame) => {
				var _opts$onStep;
				let parsed;
				try {
					parsed = JSON.parse(frame.data);
				} catch {
					return;
				}
				if (frame.event === "step") (_opts$onStep = opts.onStep) === null || _opts$onStep === void 0 || _opts$onStep.call(opts, parsed);
				else if (frame.event === "result") result = parsed;
				else if (frame.event === "error") {
					var _e$error;
					const e = parsed;
					failure = new BuddyApiError((_e$error = e.error) !== null && _e$error !== void 0 ? _e$error : "query generation failed", 502, { code: e.code });
				}
			});
			if (failure) throw failure;
			if (!result) throw new BuddyApiError("the query stream ended without a result", 502, { code: "stream_dropped" });
			if (result.understood === false) throw new BuddyApiError((_result$error = result.error) !== null && _result$error !== void 0 ? _result$error : "not understood", 422, {
				code: "not_understood",
				body: result
			});
			return result;
		},
		translations: (lang) => request("GET", `/translations/${encodeURIComponent(lang)}`, void 0, { auth: false }),
		languages: () => request("GET", "/translations/languages", void 0, { auth: false }),
		/**
		* `POST /chat/voice/transcribe` — a dictated question (16 kHz mono PCM WAV, ≤ 60 s, ≤ 2 MB; `toWav16k` in chat-ui)
		* to text. 403 `feature_disabled`, 413 `too_large`, 400 `too_long` / `unsupported_audio`, 429 `limit_exceeded`,
		* 502 `transcription_failed`.
		*/
		transcribe: async (wav, language, signal) => {
			const form = new FormData();
			form.append("audio", wav, "question.wav");
			if (language) form.append("language", language);
			return await (await requestRaw("POST", "/chat/voice/transcribe", form, {
				headers: { "Content-Type": "" },
				signal
			})).json();
		},
		/**
		* `POST /chat/voice/speak {messageId, language}` — one of the caller's answers read aloud, as MP3. `nyceTokens` is
		* what this call booked (0 when the server had it cached), `messageTokens` the answer's new token line. 403
		* `feature_disabled`, 404, 422 `nothing_to_speak`, 429 `limit_exceeded`, 502 `speech_failed`.
		*/
		speak: async (messageId, language, signal) => {
			var _response$headers$get;
			const response = await requestRaw("POST", "/chat/voice/speak", JSON.stringify({
				messageId,
				language
			}), {
				headers: { "Content-Type": "application/json" },
				accept: "audio/mpeg",
				signal
			});
			const total = response.headers.get("X-Nyce-Message-Tokens");
			return {
				audio: await response.arrayBuffer(),
				nyceTokens: Number((_response$headers$get = response.headers.get("X-Nyce-Tokens")) !== null && _response$headers$get !== void 0 ? _response$headers$get : 0),
				messageTokens: total ? Number(total) : void 0
			};
		},
		/**
		* `POST /chat/attachments` — stage the files of one question (multipart field `files`) and get their ids back.
		* They are bound to `sessionId`, so the ask body that references them must use the same session. The server
		* rejects the whole upload rather than storing part of it: 403 `feature_disabled`, 413 `too_large`, or 400
		* `too_many_files` / `too_many_images` / `file_too_large` / `unsupported_file`.
		*/
		uploadAttachments: async (files, sessionId, signal) => {
			const form = new FormData();
			for (const file of Array.from(files)) form.append("files", file, file.name);
			if (sessionId) form.append("sessionId", sessionId);
			const text = await (await requestRaw("POST", "/chat/attachments", form, {
				headers: { "Content-Type": "" },
				signal
			})).text();
			return text ? JSON.parse(text) : [];
		},
		/** Server-persisted conversations (milestone 2): the server stores every turn; the client only reads. */
		conversations: {
			list: async (q = {}) => {
				var _raw$items;
				const qs = new URLSearchParams();
				if (q.starred) qs.set("starred", "true");
				if (q.limit != null) qs.set("limit", String(q.limit));
				if (q.offset != null) qs.set("offset", String(q.offset));
				const raw = await request("GET", `/chat/conversations${qs.size ? `?${qs}` : ""}`);
				return Array.isArray(raw) ? {
					items: raw,
					total: raw.length
				} : {
					items: (_raw$items = raw.items) !== null && _raw$items !== void 0 ? _raw$items : [],
					total: raw.total
				};
			},
			get: async (id) => normalizeConversation(await request("GET", `/chat/conversations/${encodeURIComponent(id)}`)),
			getBySession: async (sessionId) => {
				try {
					return normalizeConversation(await request("GET", `/chat/conversations/session/${encodeURIComponent(sessionId)}`));
				} catch (e) {
					if (e.status === 404) return null;
					throw e;
				}
			},
			rename: (id, title) => request("PATCH", `/chat/conversations/${encodeURIComponent(id)}`, { title }),
			star: (id) => request("POST", `/chat/conversations/${encodeURIComponent(id)}/star`),
			remove: (id) => request("DELETE", `/chat/conversations/${encodeURIComponent(id)}`)
		},
		/** Full rows of a frame referenced by a report/query (`GET /chat/messages/{id}/frames/{n}`). */
		frame: async (messageId, frame, opts = {}) => {
			var _opts$offset;
			const qs = new URLSearchParams();
			if (opts.offset != null) qs.set("offset", String(opts.offset));
			if (opts.limit != null) qs.set("limit", String(opts.limit));
			return normalizeFramePage(await request("GET", `/chat/messages/${encodeURIComponent(messageId)}/frames/${frame}${qs.size ? `?${qs}` : ""}`), frame, (_opts$offset = opts.offset) !== null && _opts$offset !== void 0 ? _opts$offset : 0, opts.limit);
		},
		memory: {
			list: async () => {
				var _raw$items2;
				const raw = await request("GET", "/chat/memory");
				return Array.isArray(raw) ? raw : (_raw$items2 = raw.items) !== null && _raw$items2 !== void 0 ? _raw$items2 : [];
			},
			remove: (id) => request("DELETE", `/chat/memory/${encodeURIComponent(id)}`),
			clear: () => request("DELETE", "/chat/memory")
		},
		settings: {
			get: () => request("GET", "/chat/settings"),
			put: (settings) => request("PUT", "/chat/settings", settings)
		},
		/** The caller's pickable clients/warehouses and session codes (`GET /chat/user/filters`); lists default to empty. */
		userFilters: async (opts = {}) => {
			var _raw$available;
			const raw = await request("GET", `/chat/user/filters${opts.refresh ? "?refresh=true" : ""}`);
			return {
				...raw,
				clients: Array.isArray(raw === null || raw === void 0 ? void 0 : raw.clients) ? raw.clients : [],
				warehouses: Array.isArray(raw === null || raw === void 0 ? void 0 : raw.warehouses) ? raw.warehouses : [],
				available: (_raw$available = raw === null || raw === void 0 ? void 0 : raw.available) !== null && _raw$available !== void 0 ? _raw$available : true
			};
		},
		usage: {
			stats: (q = {}) => request("GET", `/chat/usage/stats${qs(q)}`),
			breakdown: (q = {}) => request("GET", `/chat/usage/breakdown${qs(q)}`),
			checkLimit: () => request("GET", "/chat/usage/check-limit")
		},
		feedback: {
			submit: (body) => postJsonMaybeGzip("/chat/feedback", body),
			mine: async () => {
				var _raw$items3;
				const raw = await request("GET", "/chat/feedback/mine");
				return Array.isArray(raw) ? raw : (_raw$items3 = raw.items) !== null && _raw$items3 !== void 0 ? _raw$items3 : [];
			},
			seen: (id) => request("PATCH", `/chat/feedback/mine/${encodeURIComponent(id)}/seen`),
			customerHandled: (id, comment) => request("PATCH", `/chat/feedback/mine/${encodeURIComponent(id)}/customer-handled`, { comment }),
			list: (q = {}) => request("GET", `/chat/feedback${qs(q)}`),
			setHandled: (id, body) => request("PATCH", `/chat/feedback/${encodeURIComponent(id)}/handled`, body),
			stats: (scope) => request("GET", `/chat/feedback/stats${qs({ scope })}`)
		},
		saved: {
			list: async (q = {}) => {
				var _raw$items4;
				const raw = await request("GET", `/chat/saved-queries${qs(q)}`);
				return Array.isArray(raw) ? {
					items: raw,
					total: raw.length
				} : {
					items: (_raw$items4 = raw.items) !== null && _raw$items4 !== void 0 ? _raw$items4 : [],
					total: raw.total
				};
			},
			get: (id) => request("GET", `/chat/saved-queries/${encodeURIComponent(id)}`),
			create: (body) => request("POST", "/chat/saved-queries", body),
			update: (id, body) => request("PUT", `/chat/saved-queries/${encodeURIComponent(id)}`, body),
			remove: (id) => request("DELETE", `/chat/saved-queries/${encodeURIComponent(id)}`),
			toggleFavorite: (id) => request("POST", `/chat/saved-queries/${encodeURIComponent(id)}/toggle-favorite`)
		},
		/**
		* Scheduled cards (`/chat/schedules`): a message replayed on a cron and mailed. 501 `no_storage` without storage,
		* 503 `monitoring_disabled` when agentic monitoring is off.
		*/
		schedules: {
			/** Phrase → cron + description, or `{ok: false, error}` when the phrase is not understood. */
			parse: (body, signal) => request("POST", "/chat/schedules/parse", body, { signal }),
			list: async () => {
				var _raw$items5;
				const raw = await request("GET", "/chat/schedules");
				return Array.isArray(raw) ? raw : (_raw$items5 = raw.items) !== null && _raw$items5 !== void 0 ? _raw$items5 : [];
			},
			get: (id) => request("GET", `/chat/schedules/${encodeURIComponent(id)}`),
			/**
			* Whether a schedule can run as its owner without asking the user (ADR-0022): the host mints an independent sign-in
			* (`TokenProvider.freshChain`, the embedded panel). Otherwise the UI asks for the password and passes the
			* `refreshToken` of that sign-in; the caller's own session is never handed over here.
			*/
			canMintChain: () => typeof options.auth.freshChain === "function",
			/** Hands a freshly minted sign-in over when the host can mint one and the body brings none. */
			create: async (body) => request("POST", "/chat/schedules", await withChain(body, true)),
			/** Resuming (`enabled: true`) hands a minted sign-in over too: a schedule whose stored one died needs a new one. */
			update: async (id, body) => request("PATCH", `/chat/schedules/${encodeURIComponent(id)}`, await withChain(body, body.enabled === true)),
			remove: (id) => request("DELETE", `/chat/schedules/${encodeURIComponent(id)}`),
			/** What "Create agent" would watch in an answer (its results and the since-last-run queries); nothing is stored. */
			agentPreview: (messageId, signal) => request("POST", "/chat/schedules/agent-preview", { messageId }, { signal }),
			/** Runs the card now and answers after the run. */
			runNow: (id) => request("POST", `/chat/schedules/${encodeURIComponent(id)}/run`)
		},
		/** Admin console (`/admin/*`, scope `nycebuddy:admin` or tenant/system admin groups). */
		admin: {
			tenants: {
				list: () => request("GET", "/admin/tenants"),
				get: (id) => request("GET", `/admin/tenants/${encodeURIComponent(id)}`),
				create: (body) => request("POST", "/admin/tenants", body),
				update: (id, body) => request("PUT", `/admin/tenants/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/tenants/${encodeURIComponent(id)}`)
			},
			systems: {
				list: () => request("GET", "/admin/systems"),
				get: (id) => request("GET", `/admin/systems/${encodeURIComponent(id)}`),
				create: (body) => request("POST", "/admin/systems", body),
				update: (id, body) => request("PUT", `/admin/systems/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/systems/${encodeURIComponent(id)}`),
				testConnection: (id, body) => request("POST", `/admin/systems/${encodeURIComponent(id)}/test-connection`, body !== null && body !== void 0 ? body : {}),
				refreshSchema: (id) => request("POST", `/admin/systems/${encodeURIComponent(id)}/refresh-schema`),
				schema: (id) => request("GET", `/admin/systems/${encodeURIComponent(id)}/schema`),
				/** Provisioning SQL as text (NyceBuddyV3 workflow line, groups, service user, menu element). */
				provisioningSql: async (id) => (await requestRaw("GET", `/admin/systems/${encodeURIComponent(id)}/provisioning.sql`, void 0, { accept: "text/plain" })).text(),
				/** Looks at the installation's database and reports what a provisioning run would change. */
				provisionPreview: (id, body = {}) => request("POST", `/admin/systems/${encodeURIComponent(id)}/provision/preview`, body),
				/** Writes the selected objects into the installation's database (one transaction). */
				provision: (id, body = {}) => request("POST", `/admin/systems/${encodeURIComponent(id)}/provision`, body),
				provisionRuns: (id) => request("GET", `/admin/systems/${encodeURIComponent(id)}/provision/runs`),
				/** The workflow line a run replaced, as text. */
				provisionPreviousCode: async (id, runId) => (await requestRaw("GET", `/admin/systems/${encodeURIComponent(id)}/provision/runs/${runId}/previous`, void 0, { accept: "text/plain" })).text()
			},
			/** The tenants AUTH knows (`/admin/auth-tenants`), for the system editor's tenant picker; platform admin only. */
			authTenants: () => request("GET", "/admin/auth-tenants"),
			/** Database servers nyceBuddy can reach (`/admin/db-servers`); platform admin only. */
			dbServers: {
				list: () => request("GET", "/admin/db-servers"),
				create: (body) => request("POST", "/admin/db-servers", body),
				update: (id, body) => request("PUT", `/admin/db-servers/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/db-servers/${encodeURIComponent(id)}`),
				/** The databases on the server, so an installation's database is picked rather than typed. */
				databases: (id) => request("GET", `/admin/db-servers/${encodeURIComponent(id)}/databases`),
				test: (id, database) => request("POST", `/admin/db-servers/${encodeURIComponent(id)}/test`, { database })
			},
			/** Organizations (`/admin/organizations`): the AUTH customer grouping several tenants; platform admin only. */
			organizations: {
				list: () => request("GET", "/admin/organizations"),
				get: (id) => request("GET", `/admin/organizations/${encodeURIComponent(id)}`),
				create: (body) => request("POST", "/admin/organizations", body),
				update: (id, body) => request("PUT", `/admin/organizations/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/organizations/${encodeURIComponent(id)}`)
			},
			usage: {
				overview: (q = {}) => request("GET", `/admin/usage${qs(q)}`),
				organization: (id, q = {}) => request("GET", `/admin/usage/organization/${encodeURIComponent(id)}${qs(q)}`),
				tenant: (id, q = {}) => request("GET", `/admin/usage/tenant/${encodeURIComponent(id)}${qs(q)}`),
				system: (id, q = {}) => request("GET", `/admin/usage/system/${encodeURIComponent(id)}${qs(q)}`)
			},
			limits: {
				/** Tenant rows only (the pre-organizations shape; `/admin/limits` without `scope`). */
				list: () => request("GET", "/admin/limits"),
				get: (tenantId) => request("GET", `/admin/limits/${encodeURIComponent(tenantId)}`),
				put: (tenantId, monthlyLimit) => request("PUT", `/admin/limits/${encodeURIComponent(tenantId)}`, { monthlyLimit }),
				/** `GET /admin/limits?scope=organization|tenant|system` (no scope = every row); old tenant-only rows are upgraded. */
				scoped: async (scope) => {
					return (await request("GET", `/admin/limits${qs({ scope })}`)).map((r) => r.scope ? r : {
						...r,
						scope: "tenant",
						scopeId: r.tenantId,
						name: r.tenantName,
						canEdit: true
					}).filter((r) => !scope || r.scope === scope);
				},
				/** `PUT /admin/limits/{scope}/{id} {monthlyLimit | null, isUnlimited?, warnPercent?}` */
				putScoped: (scope, id, body) => request("PUT", `/admin/limits/${encodeURIComponent(scope)}/${encodeURIComponent(id)}`, body)
			},
			/** Documentation index (`/admin/docs/*`, platform admin; 503 `docs_unavailable` without pgvector). */
			docs: {
				status: () => request("GET", "/admin/docs/status"),
				sources: {
					list: () => request("GET", "/admin/docs/sources"),
					create: (body) => request("POST", "/admin/docs/sources", body),
					update: (id, body) => request("PUT", `/admin/docs/sources/${encodeURIComponent(id)}`, body),
					remove: (id) => request("DELETE", `/admin/docs/sources/${encodeURIComponent(id)}`),
					crawl: (id, full = false) => request("POST", `/admin/docs/sources/${encodeURIComponent(id)}/crawl`, { full }),
					syncExternalShare: (id) => request("POST", `/admin/docs/sources/${encodeURIComponent(id)}/external-share/sync`),
					/** Credentials check; the body (form values) lets the admin test before saving. */
					test: (id, body) => request("POST", `/admin/docs/sources/${encodeURIComponent(id)}/test`, body)
				},
				reembed: () => request("POST", "/admin/docs/reembed"),
				/** `kinds` is the corpus filter a system's feature flags would apply; omit it to search everything. */
				search: async (q, opts = {}) => {
					var _opts$kinds, _raw$hits;
					const raw = await request("GET", `/admin/docs/search${qs({
						q,
						topK: opts.topK,
						links: opts.links,
						kinds: (_opts$kinds = opts.kinds) === null || _opts$kinds === void 0 ? void 0 : _opts$kinds.join(",")
					})}`);
					return Array.isArray(raw) ? { hits: raw } : {
						...raw,
						hits: (_raw$hits = raw.hits) !== null && _raw$hits !== void 0 ? _raw$hits : []
					};
				}
			},
			/** Skills (`/admin/skills/*`, docs/design/skills.md): reads for any admin, writes platform-only. */
			skills: {
				list: () => request("GET", "/admin/skills"),
				/** What one system's agent actually sees once the cascade and the `skills` flag are applied. */
				effective: (systemId) => request("GET", `/admin/skills/effective/${encodeURIComponent(systemId)}`),
				create: (body) => request("POST", "/admin/skills", body),
				update: (id, body) => request("PUT", `/admin/skills/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/skills/${encodeURIComponent(id)}`),
				/** The on/off switches one tenant, organization or system has, in the feature-flag shape. */
				toggles: (scope, scopeId) => request("GET", `/admin/skills/toggles/${scope}/${encodeURIComponent(scopeId)}`),
				setToggles: (scope, scopeId, skills) => request("PUT", `/admin/skills/toggles/${scope}/${encodeURIComponent(scopeId)}`, { skills }),
				/** The validation rules this build knows about, for the editor's picker. */
				validators: () => request("GET", "/admin/skills/validators"),
				/** What the rules concluded: the rates per skill and the individual outcomes. */
				validations: (opts = {}) => request("GET", `/admin/skills/validations${qs(opts)}`)
			},
			globalSettings: {
				get: () => request("GET", "/admin/global-settings"),
				put: (body) => request("PUT", "/admin/global-settings", body)
			},
			pricing: {
				list: () => request("GET", "/admin/model-pricing"),
				upsert: (body) => request("POST", "/admin/model-pricing", body),
				remove: (model) => request("DELETE", `/admin/model-pricing/${encodeURIComponent(model)}`)
			},
			translations: {
				list: (q = {}) => request("GET", `/admin/translations${qs(q)}`),
				upsert: (entry) => request("POST", "/admin/translations", entry),
				remove: (id) => request("DELETE", `/admin/translations/${encodeURIComponent(id)}`),
				autoTranslate: (language, namespace) => request("POST", "/admin/translations/auto-translate", {
					language,
					namespace
				}),
				export: async (language) => (await requestRaw("GET", `/admin/translations/export${qs({ language })}`, void 0, { accept: "application/json" })).blob(),
				import: (bundle) => request("POST", "/admin/translations/import", bundle)
			},
			failedQueries: (q = {}) => request("GET", `/admin/failed-queries${qs(q)}`),
			health: () => request("GET", "/admin/health/systems"),
			audit: (limit = 100) => request("GET", `/admin/audit${qs({ limit })}`),
			/** Request audit (`request_audit`): per-kind summary + the latest rows; tenant admins are pinned to their tenant. */
			auditRequests: (q = {}) => request("GET", `/admin/audit/requests${qs(q)}`),
			/** Agentic monitoring (`/admin/monitors/*`; 501 `no_storage` without a database). */
			monitors: {
				list: (q = {}) => request("GET", `/admin/monitors${qs(q)}`),
				get: (id) => request("GET", `/admin/monitors/${encodeURIComponent(id)}`),
				create: (body) => request("POST", "/admin/monitors", body),
				update: (id, body) => request("PUT", `/admin/monitors/${encodeURIComponent(id)}`, body),
				remove: (id) => request("DELETE", `/admin/monitors/${encodeURIComponent(id)}`),
				/** Draft a monitor from a prose description (the model, validated against the system). */
				generate: (body) => request("POST", "/admin/monitors/generate", body),
				/** Run the sources of an unsaved draft on a system: rows per source, no alerts opened. */
				testDraft: (body) => request("POST", "/admin/monitors/test-draft", body),
				test: (id, systemId) => request("POST", `/admin/monitors/${encodeURIComponent(id)}/test${qs({ systemId })}`),
				/** A real run now (alerts, emails); 409 when one is in progress. */
				run: (id, systemId) => request("POST", `/admin/monitors/${encodeURIComponent(id)}/run${qs({ systemId })}`),
				assignments: (id) => request("GET", `/admin/monitors/${encodeURIComponent(id)}/assignments`),
				assignmentsOfSystem: (systemId) => request("GET", `/admin/monitors/assignments${qs({ systemId })}`),
				assign: (id, systemId, body = {}) => request("PUT", `/admin/monitors/${encodeURIComponent(id)}/assignments/${encodeURIComponent(systemId)}`, body),
				unassign: (id, systemId) => request("DELETE", `/admin/monitors/${encodeURIComponent(id)}/assignments/${encodeURIComponent(systemId)}`),
				runs: (id, q = {}) => request("GET", `/admin/monitors/${encodeURIComponent(id)}/runs${qs(q)}`),
				runDetail: (runId) => request("GET", `/admin/monitors/runs/${encodeURIComponent(runId)}`),
				alerts: (q = {}) => {
					const { monitorId, ...rest } = q;
					return monitorId ? request("GET", `/admin/monitors/${encodeURIComponent(monitorId)}/alerts${qs(rest)}`) : request("GET", `/admin/monitors/alerts${qs(rest)}`);
				},
				clearAlerts: (id, systemId) => request("POST", `/admin/monitors/${encodeURIComponent(id)}/alerts/clear${qs({ systemId })}`),
				notifications: (id, limit) => request("GET", `/admin/monitors/${encodeURIComponent(id)}/notifications${qs({ limit })}`),
				executeAction: (alertId, index) => request("POST", `/admin/monitors/alerts/${encodeURIComponent(alertId)}/actions/${index}/execute`),
				actionLog: (alertId) => request("GET", `/admin/monitors/alerts/${encodeURIComponent(alertId)}/action-log`)
			}
		},
		/**
		* MCP connection keys (`/chat/mcp-keys`). The server takes the given refresh chain over (AUTH chains are linear), so
		* `create` prefers a chain from a fresh sign-in (`loginFor`: the settings dialog re-prompts the password and calls
		* `login`) and keeps the caller's own session; without one it hands over the provider's own chain, keeps the access
		* token the reply carries, and that session ends at expiry (`ownChainHandedOver` in the result says so).
		*/
		mcpKeys: {
			/** Whether a key can be made without a re-prompt: the provider exposes its refresh token. */
			canCreate: () => typeof options.auth.refreshToken === "function" && !!options.auth.refreshToken(),
			list: async () => {
				var _raw$items6;
				const raw = await request("GET", "/chat/mcp-keys");
				return Array.isArray(raw) ? raw : (_raw$items6 = raw.items) !== null && _raw$items6 !== void 0 ? _raw$items6 : [];
			},
			create: async (input) => {
				var _options$auth$refresh, _options$auth4, _input$expiresAt, _reply$session;
				const own = !input.refreshToken;
				const refreshToken = input.refreshToken || ((_options$auth$refresh = (_options$auth4 = options.auth).refreshToken) === null || _options$auth$refresh === void 0 ? void 0 : _options$auth$refresh.call(_options$auth4)) || null;
				if (!refreshToken) throw new BuddyApiError("No refresh token is available to bind the key to.", 0, { code: "no_refresh_token" });
				const reply = await request("POST", "/chat/mcp-keys", {
					name: input.name,
					expiresAt: (_input$expiresAt = input.expiresAt) !== null && _input$expiresAt !== void 0 ? _input$expiresAt : void 0,
					refreshToken
				});
				if (own && ((_reply$session = reply.session) === null || _reply$session === void 0 ? void 0 : _reply$session.access_token)) {
					var _options$auth$setToke, _options$auth5, _s$refresh_token;
					const s = reply.session;
					(_options$auth$setToke = (_options$auth5 = options.auth).setTokens) === null || _options$auth$setToke === void 0 || _options$auth$setToke.call(_options$auth5, {
						access_token: s.access_token,
						refresh_token: (_s$refresh_token = s.refresh_token) !== null && _s$refresh_token !== void 0 ? _s$refresh_token : "",
						expires_in: s.expires_in
					});
				}
				return {
					...reply,
					ownChainHandedOver: own
				};
			},
			revoke: (id) => request("DELETE", `/chat/mcp-keys/${encodeURIComponent(id)}`)
		},
		/**
		* Customer documents (`/admin/customer-docs`, ADR-0017): a customer's own procedures for one organization or one
		* system. Both the console and the chat's Documents drawer use it; a non-platform caller needs the `customerDocs`
		* flag on for the system it signed in at (403 `feature_disabled`) and an admin group (403 `admin_required`).
		* Indexing runs in the background, so an upload or a re-index answers `pending`: poll `list` until nothing is
		* `pending`/`indexing`.
		*/
		customerDocs: {
			/** One owner (`organizationId` or `systemId`), or neither = everything the caller may see. */
			list: (q = {}) => request("GET", `/admin/customer-docs${qs(q)}`),
			/** Multipart field `file` (1–100, ≤ 20 MB each, ≤ 200 MB in all); the server rejects the whole upload rather than part of it. */
			upload: async (files, opts = {}, signal) => {
				var _opts$title;
				const form = new FormData();
				const list = Array.from(files);
				for (const file of list) form.append("file", file, file.name);
				if (((_opts$title = opts.title) === null || _opts$title === void 0 ? void 0 : _opts$title.trim()) && list.length === 1) form.append("title", opts.title.trim());
				if (opts.organizationId) form.append("organizationId", opts.organizationId);
				else if (opts.systemId) form.append("systemId", opts.systemId);
				const text = await (await requestRaw("POST", "/admin/customer-docs", form, {
					headers: { "Content-Type": "" },
					signal
				})).text();
				return text ? JSON.parse(text) : [];
			},
			/** The original file, fetched with the bearer (a plain link would carry none). */
			download: async (id) => (await requestRaw("GET", `/admin/customer-docs/${encodeURIComponent(id)}/content`, void 0, { accept: "*/*" })).blob(),
			reindex: (id) => request("POST", `/admin/customer-docs/${encodeURIComponent(id)}/reindex`),
			remove: (id) => request("DELETE", `/admin/customer-docs/${encodeURIComponent(id)}`)
		},
		/** Pictures behind `nyce-image://` handles (see `parseImageRef`): the bytes, fetched with the bearer. 404 = no picture
		*  (or outside the caller's scope), 501 `image_unsupported` = the installation's line predates image handles. */
		images: { fetch: async (ref, opts = {}) => {
			const r = parseImageRef(ref);
			if (!r) throw new BuddyApiError(`not an image handle: ${ref}`, 400, { code: "invalid_handle" });
			return (await requestRaw("GET", `/chat/image/${r.entity}/${r.id}/${r.requisite}`, void 0, {
				accept: "image/*",
				signal: opts.signal
			})).blob();
		} },
		pdf: {
			/** `GET /chat/pdf-image/{token}/…` (anonymous; the render token is the credential): a report picture for the PDF page. */
			image: async (token, ref) => {
				const r = parseImageRef(ref);
				if (!r) throw new BuddyApiError(`not an image handle: ${ref}`, 400, { code: "invalid_handle" });
				return (await requestRaw("GET", `/chat/pdf-image/${encodeURIComponent(token)}/${r.entity}/${r.id}/${r.requisite}`, void 0, {
					auth: false,
					accept: "image/*"
				})).blob();
			},
			/** `POST /chat/pdf/export {messageId}` → PDF bytes. */
			export: async (messageId) => {
				return (await requestRaw("POST", "/chat/pdf/export", JSON.stringify({ messageId }), { accept: "application/pdf" })).blob();
			},
			/** `POST /chat/pdf/export {sessionId}` → the whole conversation as PDF bytes. */
			exportConversation: async (sessionId) => {
				return (await requestRaw("POST", "/chat/pdf/export", JSON.stringify({ sessionId }), { accept: "application/pdf" })).blob();
			},
			/** `GET /chat/pdf-data/{token}` (anonymous; rendered by the `/pdf-export` route): one answer or a conversation. */
			data: async (token) => normalizePdfPayload(await request("GET", `/chat/pdf-data/${encodeURIComponent(token)}`, void 0, { auth: false }))
		}
	};
}
// src/auth.ts
var ROLE_CLAIM_URN = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
function base64UrlDecode(segment) {
	const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
	const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "=");
	if (typeof atob === "function") {
		const bin = atob(padded);
		try {
			return decodeURIComponent(Array.from(bin, (c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join(""));
		} catch {
			return bin;
		}
	}
	const B = globalThis.Buffer;
	return B ? B.from(padded, "base64").toString("utf8") : "";
}
/**
* The system a system-bound bearer names, or undefined for a plain JWT.
*
* The API hands out `<systemId>~<jwt>` so the system travels in the Authorization header instead of a custom one (which
* MCP clients cannot send). `~` occurs in neither base64url nor a system id, so the split is unambiguous.
*/
function boundSystem(token) {
	const cut = token.indexOf("~");
	return cut > 0 && /^[a-z0-9][a-z0-9_-]{0,63}$/.test(token.slice(0, cut)) ? token.slice(0, cut) : void 0;
}
/** The bare JWT of a token that may be system-bound. */
function bareJwt(token) {
	const cut = token.indexOf("~");
	return boundSystem(token) ? token.slice(cut + 1) : token;
}
/** Decode the payload of a JWT without verifying it (the server verifies; the client only reads claims). */
function decodeJwt(token) {
	try {
		const parts = bareJwt(token).split(".");
		if (parts.length < 2) return null;
		return JSON.parse(base64UrlDecode(parts[1]));
	} catch {
		return null;
	}
}
/** `exp` claim in milliseconds since the epoch, or 0 when the token cannot be read. */
function jwtExpiryMs(token) {
	var _decodeJwt;
	const exp = (_decodeJwt = decodeJwt(token)) === null || _decodeJwt === void 0 ? void 0 : _decodeJwt.exp;
	return typeof exp === "number" ? exp * 1e3 : 0;
}
function coerceRoles(raw) {
	if (raw == null) return [];
	if (typeof raw === "string") return [raw];
	if (Array.isArray(raw)) return raw.filter((r) => typeof r === "string");
	return [];
}
/** NYCE.LOGIC groups from the `role` claims (short key and the .NET URN, string or string[]). */
function decodeTokenRoles(token) {
	const payload = decodeJwt(token);
	if (!payload) return [];
	return Array.from(/* @__PURE__ */ new Set([...coerceRoles(payload["role"]), ...coerceRoles(payload[ROLE_CLAIM_URN])]));
}
/** AUTH scopes from the `scope` claim (space separated string or array). */
function decodeTokenScopes(token) {
	var _payload$scope;
	const payload = decodeJwt(token);
	const raw = (_payload$scope = payload === null || payload === void 0 ? void 0 : payload["scope"]) !== null && _payload$scope !== void 0 ? _payload$scope : payload === null || payload === void 0 ? void 0 : payload["scp"];
	if (typeof raw === "string") return raw.split(/[\s,]+/).filter(Boolean);
	return coerceRoles(raw);
}
function rolesFromToken(token) {
	var _decodeJwt2;
	const groups = token ? decodeTokenRoles(token).map((g) => g.toUpperCase()) : [];
	const scopes = token ? decodeTokenScopes(token) : [];
	const has = (scope) => scopes.includes(scope) || scopes.includes("nycebuddy:*");
	const isTenantAdmin = groups.includes("NYCEBUDDY_TENANTADMIN");
	const sub = token ? (_decodeJwt2 = decodeJwt(token)) === null || _decodeJwt2 === void 0 ? void 0 : _decodeJwt2.sub : void 0;
	return {
		userCode: typeof sub === "string" ? sub : "",
		groups,
		scopes,
		canAsk: has("nycebuddy:ask"),
		isSystemAdmin: groups.includes("NYCEBUDDY_SYSTEMADMIN") || isTenantAdmin,
		isTenantAdmin,
		isPlatformAdmin: has("nycebuddy:admin"),
		canSendMail: groups.includes("NYCEBUDDY_SENDMAIL"),
		canCreateAgent: groups.includes("NYCEBUDDY_CREATEAGENT")
	};
}
// src/session.ts
function memoryStore() {
	const m = /* @__PURE__ */ new Map();
	return {
		get: (k) => {
			var _m$get;
			return (_m$get = m.get(k)) !== null && _m$get !== void 0 ? _m$get : null;
		},
		set: (k, v) => void m.set(k, v),
		remove: (k) => void m.delete(k)
	};
}
function webStore(storage) {
	if (!storage) return memoryStore();
	return {
		get: (k) => {
			try {
				return storage.getItem(k);
			} catch {
				return null;
			}
		},
		set: (k, v) => {
			try {
				storage.setItem(k, v);
			} catch {}
		},
		remove: (k) => {
			try {
				storage.removeItem(k);
			} catch {}
		}
	};
}
/** Access + refresh token pair kept in a store, refreshed at 60 % of its lifetime and on demand
*  (docs/design/auth.md section 2a). */
function createTokenSession(options) {
	var _options$prefix, _options$fetch, _options$refreshAt, _options$now;
	const p = (_options$prefix = options.prefix) !== null && _options$prefix !== void 0 ? _options$prefix : "nb";
	const store = options.store;
	const fetchImpl = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : ((...args) => globalThis.fetch(...args));
	const refreshAt = (_options$refreshAt = options.refreshAt) !== null && _options$refreshAt !== void 0 ? _options$refreshAt : .6;
	const now = (_options$now = options.now) !== null && _options$now !== void 0 ? _options$now : (() => Date.now());
	const K = {
		token: `${p}:token`,
		refresh: `${p}:refresh`,
		exp: `${p}:token_exp`,
		ttl: `${p}:token_ttl`
	};
	let inflight = null;
	const expMs = () => Number(store.get(K.exp)) || 0;
	const ttlMs = () => (Number(store.get(K.ttl)) || 900) * 1e3;
	const refreshDue = () => expMs() - ttlMs() * (1 - refreshAt);
	function setTokens(t) {
		store.set(K.token, t.access_token);
		if (t.refresh_token) store.set(K.refresh, t.refresh_token);
		const exp = jwtExpiryMs(t.access_token) || now() + (t.expires_in || 900) * 1e3;
		store.set(K.exp, String(exp));
		store.set(K.ttl, String(t.expires_in || Math.max(60, Math.round((exp - now()) / 1e3))));
	}
	function clear() {
		for (const k of Object.values(K)) store.remove(k);
	}
	async function refresh() {
		if (inflight) return inflight;
		const rt = store.get(K.refresh);
		if (!rt) {
			var _options$onExpired;
			(_options$onExpired = options.onExpired) === null || _options$onExpired === void 0 || _options$onExpired.call(options, "unauthorized");
			return null;
		}
		inflight = (async () => {
			try {
				const r = await fetchImpl(`${options.baseUrl.replace(/\/+$/, "")}/refresh`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ refresh_token: rt })
				});
				const d = await r.json().catch(() => ({}));
				if (r.ok && d.access_token) {
					setTokens({
						access_token: d.access_token,
						refresh_token: d.refresh_token || rt,
						expires_in: d.expires_in || 900
					});
					return d.access_token;
				}
				if (r.status === 401 || r.status === 400 || r.status === 403) {
					var _options$onExpired2;
					clear();
					(_options$onExpired2 = options.onExpired) === null || _options$onExpired2 === void 0 || _options$onExpired2.call(options, "refresh-failed");
				}
				return null;
			} catch {
				return null;
			} finally {
				inflight = null;
			}
		})();
		return inflight;
	}
	async function getToken() {
		const token = store.get(K.token);
		if (!token) return null;
		const t = now();
		if (t >= expMs() - 3e4) {
			var _await$refresh;
			return (_await$refresh = await refresh()) !== null && _await$refresh !== void 0 ? _await$refresh : t < expMs() ? token : null;
		}
		if (t >= refreshDue()) {
			const fresh = await refresh();
			return fresh !== null && fresh !== void 0 ? fresh : token;
		}
		return token;
	}
	return {
		getToken,
		refresh,
		onAuthExpired: (reason) => {
			var _options$onExpired3;
			clear();
			(_options$onExpired3 = options.onExpired) === null || _options$onExpired3 === void 0 || _options$onExpired3.call(options, reason);
		},
		setTokens,
		peek: () => store.get(K.token),
		refreshToken: () => store.get(K.refresh),
		isSignedIn: () => !!store.get(K.token),
		msUntilRefresh: () => refreshDue() - now(),
		clear,
		startAutoRefresh() {
			let timer;
			let stopped = false;
			const schedule = () => {
				if (stopped || !store.get(K.token)) return;
				const wait = Math.max(5e3, refreshDue() - now());
				timer = setTimeout(async () => {
					await refresh();
					schedule();
				}, wait);
			};
			schedule();
			return () => {
				stopped = true;
				if (timer) clearTimeout(timer);
			};
		}
	};
}
export { BuddyApiError, DEFAULT_RESUME_DELAYS, DEFAULT_STALL_MS, IMAGE_REF_SCHEME, SseParser, abortError, bareJwt, boundSystem, createBuddyClient, createTokenSession, decodeJwt, decodeTokenRoles, decodeTokenScopes, errorFromResponse, imageRefPath, isAbortError, isEventStream, isImageRef, isStallError, jwtExpiryMs, memoryStore, normalizeConversation, normalizeFinalResult, normalizeFramePage, normalizeMessage, normalizeReport, normalizeRows, normalizeStreamEvent, normalizeUsage, parseImageRef, readSse, rolesFromToken, stallError, webStore };

//# sourceMappingURL=index.js.map